import { useEffect } from "react";
import { IUserModel } from "./useAuthentication";

/**
 * Hook to apply the user's font size preference to the document root element.
 * This allows all rem-based font sizes throughout the app to scale accordingly.
 *
 * @param currentUser - The currently authenticated user with fontSizePercent preference
 */
export const useFontSizePreference = (currentUser: IUserModel | null) => {
  useEffect(() => {
    if (currentUser?.fontSizePercent) {
      // Convert percentage to px (100% = 16px, 125% = 20px, etc.)
      const fontSizeInPx = (currentUser.fontSizePercent / 100) * 16;
      document.documentElement.style.fontSize = `${fontSizeInPx}px`;
    } else {
      // Reset to default if no user or no preference
      document.documentElement.style.fontSize = "16px";
    }

    // Cleanup: Reset font size when user logs out or component unmounts
    return () => {
      if (!currentUser) {
        document.documentElement.style.fontSize = "16px";
      }
    };
  }, [currentUser?.fontSizePercent]);
};
